import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

// 标签类型新增
export function bqlxAdd(data = {}) {
  return request({
    url: `/${systemConfig.businessPrefix}/bqLxb/${systemConfig.version_1}/add`,
    method: 'post',
    data,
  })
}
// 标签类型修改
export function bqlxUpdate(data = {}) {
    return request({
        url: `/${systemConfig.businessPrefix}/bqLxb/${systemConfig.version_1}/update`,
        method: 'post',
        data,
    })
}
// 标签类型删除
export function bqlxDel(data = {}) {
  return request({
      url: `/${systemConfig.businessPrefix}/bqLxb/${systemConfig.version_1}/delete`,
      method: 'post',
      data,
  })
}
// 标签类型详情
export function bqlxDetail(data = {}) {
  return request({
      url: `/${systemConfig.businessPrefix}/bqLxb/${systemConfig.version_1}/detail`,
      method: 'post',
      data,
  })
}
// 标签类型树列表
export function bqlxTree(data = {}) {
    return request({
        url: `/${systemConfig.businessPrefix}/bqLxb/${systemConfig.version_1}/tree`,
        method: 'post',
        data,
    })
}
// 标签类型下拉树列表
export function bqlxTreeSelect(data = {}) {
    return request({
        url: `/${systemConfig.businessPrefix}/bqLxb/${systemConfig.version_1}/treeSelect`,
        method: 'post',
        data,
    })
}
// 根据标签Code获取标签下级数据
export function bqlxQueryBqLxbByCode(data = {}) {
  return request({
    url: `/${systemConfig.businessPrefix}/bqLxb/${systemConfig.version_1}/queryBqLxbByCode`,
    method: 'post',
    data,
  })
}
// 标签数据新增
export function bqAdd(data = {}) {
    return request({
      url: `/${systemConfig.businessPrefix}/bqXxb/${systemConfig.version_1}/add`,
      method: 'post',
      data,
    })
}
// 标签数据修改
export function bqUpdate(data = {}) {
    return request({
      url: `/${systemConfig.businessPrefix}/bqXxb/${systemConfig.version_1}/update`,
      method: 'post',
      data,
    })
}
// 标签数据删除
export function bqDel(data = {}) {
    return request({
      url: `/${systemConfig.businessPrefix}/bqXxb/${systemConfig.version_1}/delete`,
      method: 'post',
      data,
    })
}
// 标签数据详情
export function bqDetail(data = {}) {
  return request({
    url: `/${systemConfig.businessPrefix}/bqXxb/${systemConfig.version_1}/detail`,
    method: 'post',
    data,
  })
}
// 标签数据分页
export function bqPage(data = {}) {
    return request({
      url: `/${systemConfig.businessPrefix}/bqXxb/${systemConfig.version_1}/page`,
      method: 'post',
      data,
    })
}